import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormGroup, InputGroup, Button, ControlLabel, FormControl } from 'react-bootstrap';
import { required, formatParticipant } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, readOnly, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} readOnly={readOnly} />
    {touched && ((error && <span className="error-text"> ({error})</span>) || (warning && <span>{warning}</span>))}
  </InputGroup>
);

const GroupDetailForm = props => {
  const { handleSubmit, changeValue, roomtype, isEdit, pristine, reset, submitting, event, places } = props;
  const style ={'color':'red'}
  const margin ={'marginRight':'10%'}
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="name"
            type="text"
            component={renderBootstrapField}
            label="Name"
            validate={[required]}
            onChange={(e)=>changeValue(e)}
          />
          <Field
            name="members_count"
            type="number"
            component={renderBootstrapField}
            label="Number of Members"
            readOnly={isEdit}
            disabled={true}            
            validate={[formatParticipant]}
            onChange={(e)=>changeValue(e)}
          />
        </FormGroup>
        <FormGroup>
          <br/><p>Please add number of rooms types for group members:</p>
          <label>Suite:</label>&nbsp;<input type="number" name="suite" size="20" readOnly={isEdit} onChange={roomtype} style={margin} />
          <label>King:</label>&nbsp;<input type="number" name="king" size="20" readOnly={isEdit} onChange={roomtype} style={margin}/>
          <label>Double:</label>&nbsp;<input type="number" name="double" size="20" readOnly={isEdit} onChange={roomtype}/>
        </FormGroup>
        <FormGroup>
          <Button disabled={pristine || submitting} bsStyle="info" type="submit">
            Save
          </Button>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'groupDetailForm', // a unique identifier for this form
})(GroupDetailForm);


// WEBPACK FOOTER //
// src/routes/tours/components/GroupDetailForm.js